import useSEO from "@/hooks/useSEO";
import useLatestApk from "@/hooks/useLatestApk";
import { PageHeader } from "@/components/PageHeader";
import { DownloadCard } from "@/components/DownloadCard";
import { FAQ } from "@/components/FAQ";
import { Reveal } from "@/components/Reveal";
import useT from "@/i18n";
import { breadcrumbLd, faqLd, softwareLd, webPageLd } from "@/lib/seo";

export default function Download() {
  const { apk } = useLatestApk();
  const { t: T, lp } = useT();
  const t = T.download;
  const path = "/download";
  const title = t.seoTitle(apk?.version_name);
  const description = t.seoDesc(apk?.version_name);
  const crumbs = [{ name: t.crumb, path }];
  useSEO({ title, description, path, jsonLd: [webPageLd({ title, description, path: lp(path) }), breadcrumbLd(crumbs, T.crumbs.home, lp), softwareLd(apk, lp), faqLd(t.faq)] });

  return (
    <div data-testid="download-page">
      <PageHeader crumbs={crumbs} badge={t.badge} title={t.title} intro={t.intro} />
      <section className="max-w-7xl mx-auto safe-x sm:px-8 grid lg:grid-cols-12 gap-10 pb-16" aria-labelledby="install-heading">
        <div className="lg:col-span-7 min-w-0"><DownloadCard /></div>
        <Reveal className="lg:col-span-5">
          <h2 id="install-heading" className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{t.howTitle}</h2>
          <ol className="mt-6 space-y-4">
            {t.steps.map(([t, d], i) => (
              <li key={t} className="glass rounded-2xl p-5 flex gap-4" data-testid={`install-step-${i}`}>
                <span className="font-mono-alt text-[#00BFFF] text-sm shrink-0 w-8 h-8 rounded-full flex items-center justify-center border" style={{ borderColor: "rgba(0,191,255,.35)" }} aria-hidden="true">{i + 1}</span>
                <div><h3 className="font-display font-semibold">{t}</h3><p className="text-sm text-slate-400 mt-1 leading-relaxed">{d}</p></div>
              </li>
            ))}
          </ol>
        </Reveal>
      </section>
      <section className="max-w-4xl mx-auto safe-x sm:px-8 py-16" aria-labelledby="download-faq-heading">
        <h2 id="download-faq-heading" className="font-display text-3xl sm:text-4xl font-bold tracking-tight">{t.faqTitle}</h2>
        <div className="mt-8"><FAQ key={T.htmlLang} items={t.faq} prefix="download-faq" /></div>
      </section>
    </div>
  );
}
